import React from 'react'
import Dashboard from '../dashboard'
import BillView from './page'

const Bill = () => {
  return <Dashboard component={<BillView />} />
}

export default Bill
